import { ExpertiseEnum } from "@/lib/expertiseEnum";
import { getMessages } from "@/lib/i18n/messages";
import type { Locale } from "@/lib/i18n/locales";

export const featuredAwardIds = {
  handelsblattOnesToWatch2026: "handelsblattOnesToWatch2026",
} as const;

export type FeaturedAwardId =
  (typeof featuredAwardIds)[keyof typeof featuredAwardIds];

export const FEATURED_AWARD_IMAGE_URLS: Record<FeaturedAwardId, string> = {
  handelsblattOnesToWatch2026:
    "/images/recognitions/dr-hubertus-scherbarth-handelsblatt-best-lawyers-ones-to-watch-2026-gesellschaftsrecht-steuerrecht.png",
};

export interface FeaturedAward {
  id: FeaturedAwardId;
  imageUrl: string;
  imageAlt: string;
}

/** Expertise areas that display a featured award badge beside the intro text. */
export const EXPERTISE_FEATURED_AWARD_IDS: Partial<
  Record<ExpertiseEnum, FeaturedAwardId[]>
> = {
  [ExpertiseEnum.Gesellschaftsrecht]: ["handelsblattOnesToWatch2026"],
  [ExpertiseEnum.Insolvenzrecht]: ["handelsblattOnesToWatch2026"],
  [ExpertiseEnum.Startuprecht]: ["handelsblattOnesToWatch2026"],
  [ExpertiseEnum.Steuerrecht]: ["handelsblattOnesToWatch2026"],
};

export function resolveFeaturedAwards(
  ids: FeaturedAwardId[] | undefined,
  locale: Locale,
): FeaturedAward[] | undefined {
  if (!ids?.length) {
    return undefined;
  }

  const altById = getMessages(locale).common.featuredAwards;

  return ids.map((id) => ({
    id,
    imageUrl: FEATURED_AWARD_IMAGE_URLS[id],
    imageAlt: altById[id].imageAlt,
  }));
}

export function getFeaturedAwardsForExpertise(
  expertise: ExpertiseEnum,
  locale: Locale,
): FeaturedAward[] | undefined {
  return resolveFeaturedAwards(EXPERTISE_FEATURED_AWARD_IDS[expertise], locale);
}
